const BANGKOK_OFFSET_MS = 7 * 60 * 60 * 1000
const DAY_MS = 24 * 60 * 60 * 1000
const LOCALES = { th: 'th-TH-u-ca-gregory', en: 'en-GB' }

const inBangkok = (iso) => {
  const ms = Date.parse(iso)
  return Number.isNaN(ms) ? null : new Date(ms + BANGKOK_OFFSET_MS)
}

const bangkokDayKey = (iso) => {
  const shifted = inBangkok(iso)
  return shifted ? shifted.toISOString().slice(0, 10) : null
}

const bangkokClock = (iso) => {
  const shifted = inBangkok(iso)
  return shifted ? shifted.toISOString().slice(11, 16) : ''
}

const daysBetween = (fromDayKey, toDayKey) =>
  Math.round((Date.parse(toDayKey) - Date.parse(fromDayKey)) / DAY_MS)

const formatShifted = (iso, lang, options) => {
  const shifted = inBangkok(iso)
  if (!shifted) return ''
  return new Intl.DateTimeFormat(LOCALES[lang] || LOCALES.en, { timeZone: 'UTC', ...options }).format(shifted)
}

const formatDay = (iso, lang) =>
  formatShifted(iso, lang, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' })

const formatDate = (iso, lang) =>
  formatShifted(iso, lang, { day: 'numeric', month: 'short', year: 'numeric' })

const formatDateTime = (iso, lang) => {
  const date = formatDate(iso, lang)
  return date && `${date} ${bangkokClock(iso)}`
}

const formatTimeRange = (firstAt, lastAt) => {
  const first = bangkokClock(firstAt)
  const last = bangkokClock(lastAt)
  return !last || first === last ? first : `${first}–${last}`
}

export {
  bangkokDayKey,
  bangkokClock,
  daysBetween,
  formatDay,
  formatDate,
  formatDateTime,
  formatTimeRange
}
